import './styles.scss';
import AttributeSelector from '../AttributeSelector';
import autobind from 'autobind-decorator';
import React, { Component } from 'react';
import { Button, Input, InputGroup, InputGroupAddon, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ordersService } from '../../services/Orders';
import { Redirect, withRouter } from 'react-router-dom';
import uah from '../../filters/uah';
import { noun } from 'plural-ru';
import ShowMore from 'react-show-more';
import SaleOff from '../SaleOff';

class ProductDetails extends Component {
  state = {
    sizes: [
      { title: 'XS', disabled: false },
      { title: 'S', disabled: false },
      { title: 'M', disabled: false },
      { title: 'L', disabled: true },
      { title: 'XL', disabled: false },
      { title: 'XXL', disabled: true }
    ],
    added: false,
    modalOpened: false,
    selectedBrand: '',
    selectedSize: '',
    quantity: 1,
    price: 400
  };
  images = [
    { src: 'https://images.ua.prom.st/1616027834_w640_h640_bryuki-muzhskie-yoshimitsu.jpg', key: 1 },
    { src: 'https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg', key: 2 },
    { src: 'https://kh-news.net/images/stories/main/remen/kak-pravilno-vybrat-remen-dlya-muzhchiny-foto2.jpg', key: 3 }
  ];

  get isFormValid() {
    const qty = parseInt(this.state.quantity, 10);
    return Boolean(qty > 0 && qty <= 100 && this.state.selectedBrand && this.state.selectedSize);
  }

  get isQuantityValid() {
    return this.state.quantity > 1 && this.state.quantity <= 100;
  }

  get sumPrise() {
    if (this.isQuantityValid) {
      return this.state.price * this.state.quantity;
    } else {
      return this.state.price;
    }
  }

  @autobind
  onQuantityChange(e) {
    this.setState({
      quantity: e.target.value
    });
  }

  @autobind
  onAddClick() {
    if (this.state.added) {
      return this.props.history.push('/new-order');
    }

    ordersService.selectProduct({});
    this.setState({
      added: true
    });
  }

  @autobind
  onBrandSelect(selectedBrand) {
    this.setState({
      selectedBrand
    });
  }

  @autobind
  onSizeSelect(selectedSize) {
    this.setState({
      selectedSize
    });
  }

  @autobind
  showSizeTableModal() {
    this.setState({ modalOpened: true });
  }

  @autobind
  hideSizeTableModal() {
    this.setState({ modalOpened: false });
  }

  render() {
    return (
      <div className="product-details">
        <aside className={`product-details_left ${ordersService.state.isSelectingProducts && '__with-selecting'}`}>
          <div className="product-details_image" style={{ backgroundImage: `url(${this.images[0].src})` }}></div>
          <div className="product-details_image" style={{ backgroundImage: `url(${this.images[0].src})` }}></div>
          <div className="product-details_image" style={{ backgroundImage: `url(${this.images[1].src})` }}></div>
          <div className="product-details_image" style={{ backgroundImage: `url(${this.images[2].src})` }}></div>
          <div className="product-details_image" style={{ backgroundImage: `url(${this.images[2].src})` }}></div>
          <div className="product-details_image" style={{ backgroundImage: `url(${this.images[1].src})` }}></div>
          <div className="product-details_image" style={{ backgroundImage: `url(${this.images[0].src})` }}></div>
        </aside>

        <section className="product-details_right">
          <div className="product-details_block">
            <div className="product-details_block_heading">Артикль</div>
            DGH47R
          </div>

          <div className="product-details_block">
            <div className="product-details_block_heading">Описание</div>
            <ShowMore more='Показать еще' less='Скрыть'>
              Таким хитроумным способом Винда демонстрирует юзеру, каким образом выглядят буквы в кириллических шрифтах для пользователей перевода Windows для России (болгарам же и другим пользователям кириллических шрифтов на эти ваши булки положить с прибором). Выбор именно этой фразы оправдывается тем, что в ней содержатся все буквы русского алфавита, а также запятая и точка (такие фразы именуются «панграммами»).
            </ShowMore>
          </div>

          <div className="product-details_block">
            <div className="product-details_block_heading">Материал</div>
            Флис, ткань
          </div>

          <div className="product-details_block">
            <div className="product-details_block_heading">Бренд</div>

            <AttributeSelector items={['Puma', 'Adidas', 'NB', 'Nike']} onSelect={this.onBrandSelect}/>
          </div>

          <div className="product-details_block">
            <div className="product-details_block_heading">Размер</div>

            <AttributeSelector items={this.state.sizes} sorting={false} onSelect={this.onSizeSelect}/>
            &nbsp;&nbsp;&nbsp;
            <Button size="sm" color="info" outline onClick={this.showSizeTableModal}>Таблица</Button>
            <Modal isOpen={this.state.modalOpened} toggle={this.hideSizeTableModal}>
              <ModalHeader>Таблица размеров</ModalHeader>
              <ModalBody>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.hideSizeTableModal}>Закрыть</Button>
              </ModalFooter>
            </Modal>

            <div hidden={this.state.selectedSize !== 'XL'}><sub>Осталось 5 едениц размера XL</sub></div>
          </div>

          <div className="product-details_block">
            <div className="product-details_block_heading">Дроп цена &nbsp; <span className="box-danger">25% Скидка</span></div>
            <SaleOff>{uah(this.sumPrise)}</SaleOff>
            {uah(this.sumPrise, .25)}
            {this.isQuantityValid && (<> за {noun(this.state.quantity, '%d еденицу', '%d еденицы', '%d едениц')}</>)}
          </div>

          <InputGroup className="mt-4 float-left">
            <Input value={this.state.quantity} onChange={this.onQuantityChange}/>
            <InputGroupAddon addonType="append">
              <Button color={this.state.added ? 'success' : 'primary'} onClick={this.onAddClick} disabled={!this.isFormValid}>
                <FontAwesomeIcon hidden={!this.state.added} icon={faCheck} size="sm"></FontAwesomeIcon> {this.state.added ? 'Перейти к заказу' : 'Добавить в заказ'}
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </section>
      </div>
    );
  }
}

export default withRouter(ProductDetails);
